import { IconExternalLink } from "@tabler/icons-react";
import { useRouter } from "next/router";

import { Modal } from "~/components/_design-system/Modal";
import { appConstants } from "~/shared/constants/app.constants";
import { Button, Flex, List, Text } from "~/ui";

interface OrgOnboardingModeModalProps {
  active: boolean;
  onClose: () => void;
}
export const OrgOnboardingModeModal = (props: OrgOnboardingModeModalProps) => {
  const router = useRouter();
  const orgRoutePath = router.route.replace("[orgSlug]", router.query.orgSlug as string);
  const sandboxRedirectUrl = `${appConstants.sandboxUrl}${orgRoutePath}`;

  return (
    <Modal active={props.active} title="Onboarding Mode" onClose={props.onClose}>
      <Flex direction="column" gap="md">
        <Text>
          Your organization is currently in <strong>onboarding mode</strong> — a temporary setup state within production.
        </Text>
        <List spacing="sm" withPadding>
          <List.Item>This mode allows you to configure your account and test workflows safely.</List.Item>
          <List.Item>
            Operational data such as orders, shipments, inventory transactions, and financial records entered during onboarding will be
            permanently deleted at go-live.
          </List.Item>
          <List.Item>Master data like customers, products, and account configurations will be retained.</List.Item>
        </List>
        <Text>
          To explore ShelfCycle without risk to production setup, you may also{" "}
          <Button
            compact
            component="a"
            target="_blank"
            href={sandboxRedirectUrl}
            rightIcon={<IconExternalLink size="1rem" />}
            variant="subtle"
          >
            Explore Sandbox
          </Button>
          , which resets weekly and is intended for open-ended testing.
        </Text>
      </Flex>
    </Modal>
  );
};
